export default {
  title: 'Dodaj kartę',
  buttons: {
    save: 'Zapisz',
  },
  feedback: {
    success: 'Karta zapisana pomyślnie',
  },
};
